var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"h-2 w-full bg-gray-100"},[_c('div',{class:['leading-none h-full bg-gray-800'],style:(_vm.barStyle)})])])])}
var staticRenderFns = []

export { render, staticRenderFns }